import { render, staticRenderFns } from "./multiple.vue?vue&type=template&id=866c0dd8&scoped=true&"
import script from "./multiple.vue?vue&type=script&lang=js&"
export * from "./multiple.vue?vue&type=script&lang=js&"
import style0 from "./multiple.vue?vue&type=style&index=0&id=866c0dd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "866c0dd8",
  null
  
)

export default component.exports